import Vue from "vue";
import Vuetify from "vuetify";

// VCurrencyField
import VCurrencyField from "v-currency-field";
Vue.use(VCurrencyField, {
    locale: "kr-KR",
    decimalLength: 0,
    autoDecimalMode: false,
    defaultValue: 0,
    min: null,
    max: null,
    valueAsInteger: false,
    allowNegative: true,
});

Vue.use(Vuetify);

export const basicTheme = {
    themes: {
        light: {
            primary: {
                lighten5: "#FAB5BE",
                lighten4: "#F66D7F",
                lighten3: "#F23850",
                lighten2: "#D50E28",
                lighten1: "#B90C22",
                base: "#9C0A1D",
                darken1: "#7F0818",
                darken2: "#620612",
                darken3: "#46040D",
                darken4: "#290308",
                accent1: "#FFA6B2",
                accent2: "#FF4059",
                accent3: "#D9001C",
                accent4: "#B9071E",
            },
            secondary: {
                lighten5: "#F6F3F1",
                lighten4: "#F4C8BF",
                lighten3: "#EC9F8F",
                lighten2: "#E16B52",
                lighten1: "#DD5538",
                base: "#D24324",
                darken1: "#B83B20",
                darken2: "#9E321B",
                darken3: "#842A17",
                darken4: "#692212",
                accent1: "#FFF8F6",
                accent2: "#FFA490",
                accent3: "#F05A39",
                accent4: "#E24E2D",
            },
            accent: {
                lighten5: "#FAF1F0",
                lighten4: "#FEF9F8",
                lighten3: "#F9CCC6",
                lighten2: "#F29285",
                lighten1: "#EF7A6A",
                base: "#EC614E",
                darken1: "#E94832",
                darken2: "#E43119",
                darken3: "#C92B16",
                darken4: "#AD2513",
                accent1: "#FFF8F8",
                accent2: "#FFD9D4",
                accent3: "#FC8271",
                accent4: "#F37261",
            },
            grey: {
                lighten5: "#f8f8f8",
                lighten4: "#e6e6e6",
                lighten3: "#ddd",
                lighten2: "#aaa",
                lighten1: "#999",
                base: "#666",
                darken1: "#555",
                darken2: "#444",
                darken3: "#333",
                darken4: "#111",
            },
            amber: {
                lighten1: "#f4c923",
            },
            success: "#4CAF50",
            warning: "#FFC107",
            error: "#FF5252",
            info: "#2196F3",
            anchor: "inherit",
        },
    },
    options: { customProperties: true },
};

export const consoleTheme = {
    themes: {
        light: {
            primary: "#00C73C",
            secondary: "#445163",
            accent: "#00C73C",
            info: "#2D3539",
            content: "#EDF0F5",
            anchor: "#333",
        },
    },
};

/**
 *
 * @param {(basicTheme|consoleTheme)} theme
 * @returns
 */
export default function (theme) {
    return new Vuetify({
        lang: {
            locales: { ko: require("vuetify/lib/locale/ko") },
            current: "ko",
        },
        breakpoint: {
            mobileBreakpoint: "md",
            thresholds: {
                xs: 576,
                sm: 768,
                md: 1024,
                lg: 1200,
            },
            scrollBarWidth: 0,
        },
        theme: theme || basicTheme,
    });
}
